[
  {
    "name": "Spacing",
    "values": [
      {
        "mode": {
          "name": "Mobile",
          "id": "1418:0"
        },
        "color": [],
        "number": [
          {
            "name": "Margins/Component Level/bottom-none",
            "value": "0rem",
            "var": "System Spacing/spacing-none",
            "rootAlias": "System Spacing/spacing-none"
          },
          {
            "name": "Margins/Component Level/horizontal-tight",
            "value": "0.25rem",
            "var": "System Spacing/spacing-xxxs",
            "rootAlias": "System Spacing/spacing-xxxs"
          },
          {
            "name": "Margins/Component Level/horizontal-default",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Margins/Component Level/top-tight",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Margins/Component Level/vertical-cards",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Margins/Component Level/horizontal-comfortable",
            "value": "1rem",
            "var": "System Spacing/spacing-sm",
            "rootAlias": "System Spacing/spacing-sm"
          },
          {
            "name": "Margins/Component Level/top-dense",
            "value": "1rem",
            "var": "System Spacing/spacing-sm",
            "rootAlias": "System Spacing/spacing-sm"
          },
          {
            "name": "Margins/Component Level/component-grid",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Margins/Component Level/top-default",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Margins/Component Level/vertical-inputs",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Margins/Page Level/top-page",
            "value": "0rem",
            "var": "System Spacing/spacing-none",
            "rootAlias": "System Spacing/spacing-none"
          },
          {
            "name": "Margins/Page Level/focus-page",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Margins/Page Level/left-page",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Margins/Page Level/right-page",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Margins/Page Level/bottom-page",
            "value": "3rem",
            "var": "System Spacing/spacing-xl",
            "rootAlias": "System Spacing/spacing-xl"
          },
          {
            "name": "Padding/component-compact",
            "value": "0.25rem",
            "var": "System Spacing/spacing-xxxs",
            "rootAlias": "System Spacing/spacing-xxxs"
          },
          {
            "name": "Padding/table-cell-compact",
            "value": "0.25rem",
            "var": "System Spacing/spacing-xxxs",
            "rootAlias": "System Spacing/spacing-xxxs"
          },
          {
            "name": "Padding/component-default",
            "value": "0.5rem",
            "var": "System Spacing/spacing-xxs",
            "rootAlias": "System Spacing/spacing-xxs"
          },
          {
            "name": "Padding/icon-text-padding",
            "value": "0.5rem",
            "var": "System Spacing/spacing-xxs",
            "rootAlias": "System Spacing/spacing-xxs"
          },
          {
            "name": "Padding/table-cell-default",
            "value": "0.5rem",
            "var": "System Spacing/spacing-xxs",
            "rootAlias": "System Spacing/spacing-xxs"
          },
          {
            "name": "Padding/component-comfortable",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Padding/table-cell-comfortable",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Padding/card-padding-compact",
            "value": "1rem",
            "var": "System Spacing/spacing-sm",
            "rootAlias": "System Spacing/spacing-sm"
          },
          {
            "name": "Padding/card-padding-default",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Padding/table-cell-first",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "System Spacing/spacing-none",
            "value": "0rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxxs",
            "value": "0.25rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxs",
            "value": "0.5rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xs",
            "value": "0.75rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-sm",
            "value": "1rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-md",
            "value": "1.5rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-lg",
            "value": "2rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xl",
            "value": "3rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxl",
            "value": "4rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxxl",
            "value": "6rem",
            "var": "",
            "rootAlias": ""
          }
        ]
      },
      {
        "mode": {
          "name": "Tablet Portrait",
          "id": "3062:6"
        },
        "color": [],
        "number": [
          {
            "name": "Margins/Component Level/bottom-none",
            "value": "0rem",
            "var": "System Spacing/spacing-none",
            "rootAlias": "System Spacing/spacing-none"
          },
          {
            "name": "Margins/Component Level/horizontal-tight",
            "value": "0.25rem",
            "var": "System Spacing/spacing-xxxs",
            "rootAlias": "System Spacing/spacing-xxxs"
          },
          {
            "name": "Margins/Component Level/horizontal-default",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Margins/Component Level/top-tight",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Margins/Component Level/vertical-cards",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Margins/Component Level/horizontal-comfortable",
            "value": "1rem",
            "var": "System Spacing/spacing-sm",
            "rootAlias": "System Spacing/spacing-sm"
          },
          {
            "name": "Margins/Component Level/top-dense",
            "value": "1rem",
            "var": "System Spacing/spacing-sm",
            "rootAlias": "System Spacing/spacing-sm"
          },
          {
            "name": "Margins/Component Level/top-default",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Margins/Component Level/vertical-inputs",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Margins/Component Level/component-grid",
            "value": "3rem",
            "var": "System Spacing/spacing-xl",
            "rootAlias": "System Spacing/spacing-xl"
          },
          {
            "name": "Margins/Page Level/top-page",
            "value": "0rem",
            "var": "System Spacing/spacing-none",
            "rootAlias": "System Spacing/spacing-none"
          },
          {
            "name": "Margins/Page Level/focus-page",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Margins/Page Level/left-page",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Margins/Page Level/right-page",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Margins/Page Level/bottom-page",
            "value": "4rem",
            "var": "System Spacing/spacing-xxl",
            "rootAlias": "System Spacing/spacing-xxl"
          },
          {
            "name": "Padding/component-compact",
            "value": "0.25rem",
            "var": "System Spacing/spacing-xxxs",
            "rootAlias": "System Spacing/spacing-xxxs"
          },
          {
            "name": "Padding/table-cell-compact",
            "value": "0.25rem",
            "var": "System Spacing/spacing-xxxs",
            "rootAlias": "System Spacing/spacing-xxxs"
          },
          {
            "name": "Padding/component-default",
            "value": "0.5rem",
            "var": "System Spacing/spacing-xxs",
            "rootAlias": "System Spacing/spacing-xxs"
          },
          {
            "name": "Padding/icon-text-padding",
            "value": "0.5rem",
            "var": "System Spacing/spacing-xxs",
            "rootAlias": "System Spacing/spacing-xxs"
          },
          {
            "name": "Padding/table-cell-default",
            "value": "0.5rem",
            "var": "System Spacing/spacing-xxs",
            "rootAlias": "System Spacing/spacing-xxs"
          },
          {
            "name": "Padding/component-comfortable",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Padding/table-cell-comfortable",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Padding/card-padding-compact",
            "value": "1rem",
            "var": "System Spacing/spacing-sm",
            "rootAlias": "System Spacing/spacing-sm"
          },
          {
            "name": "Padding/card-padding-default",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Padding/table-cell-first",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "System Spacing/spacing-none",
            "value": "0rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxxs",
            "value": "0.25rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxs",
            "value": "0.5rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xs",
            "value": "0.75rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-sm",
            "value": "1rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-md",
            "value": "1.5rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-lg",
            "value": "2rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xl",
            "value": "3rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxl",
            "value": "4rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxxl",
            "value": "6rem",
            "var": "",
            "rootAlias": ""
          }
        ]
      },
      {
        "mode": {
          "name": "Laptop",
          "id": "3062:7"
        },
        "color": [],
        "number": [
          {
            "name": "Margins/Component Level/bottom-none",
            "value": "0rem",
            "var": "System Spacing/spacing-none",
            "rootAlias": "System Spacing/spacing-none"
          },
          {
            "name": "Margins/Component Level/horizontal-tight",
            "value": "0.25rem",
            "var": "System Spacing/spacing-xxxs",
            "rootAlias": "System Spacing/spacing-xxxs"
          },
          {
            "name": "Margins/Component Level/horizontal-default",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Margins/Component Level/top-tight",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Margins/Component Level/vertical-cards",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Margins/Component Level/horizontal-comfortable",
            "value": "1rem",
            "var": "System Spacing/spacing-sm",
            "rootAlias": "System Spacing/spacing-sm"
          },
          {
            "name": "Margins/Component Level/top-dense",
            "value": "1rem",
            "var": "System Spacing/spacing-sm",
            "rootAlias": "System Spacing/spacing-sm"
          },
          {
            "name": "Margins/Component Level/vertical-inputs",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Margins/Component Level/top-default",
            "value": "2rem",
            "var": "System Spacing/spacing-lg",
            "rootAlias": "System Spacing/spacing-lg"
          },
          {
            "name": "Margins/Component Level/component-grid",
            "value": "3rem",
            "var": "System Spacing/spacing-xl",
            "rootAlias": "System Spacing/spacing-xl"
          },
          {
            "name": "Margins/Page Level/top-page",
            "value": "0rem",
            "var": "System Spacing/spacing-none",
            "rootAlias": "System Spacing/spacing-none"
          },
          {
            "name": "Margins/Page Level/left-page",
            "value": "3rem",
            "var": "System Spacing/spacing-xl",
            "rootAlias": "System Spacing/spacing-xl"
          },
          {
            "name": "Margins/Page Level/right-page",
            "value": "3rem",
            "var": "System Spacing/spacing-xl",
            "rootAlias": "System Spacing/spacing-xl"
          },
          {
            "name": "Margins/Page Level/bottom-page",
            "value": "6rem",
            "var": "System Spacing/spacing-xxxl",
            "rootAlias": "System Spacing/spacing-xxxl"
          },
          {
            "name": "Margins/Page Level/focus-page",
            "value": "15rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "Padding/component-compact",
            "value": "0.25rem",
            "var": "System Spacing/spacing-xxxs",
            "rootAlias": "System Spacing/spacing-xxxs"
          },
          {
            "name": "Padding/table-cell-compact",
            "value": "0.25rem",
            "var": "System Spacing/spacing-xxxs",
            "rootAlias": "System Spacing/spacing-xxxs"
          },
          {
            "name": "Padding/component-default",
            "value": "0.5rem",
            "var": "System Spacing/spacing-xxs",
            "rootAlias": "System Spacing/spacing-xxs"
          },
          {
            "name": "Padding/icon-text-padding",
            "value": "0.5rem",
            "var": "System Spacing/spacing-xxs",
            "rootAlias": "System Spacing/spacing-xxs"
          },
          {
            "name": "Padding/table-cell-default",
            "value": "0.5rem",
            "var": "System Spacing/spacing-xxs",
            "rootAlias": "System Spacing/spacing-xxs"
          },
          {
            "name": "Padding/component-comfortable",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Padding/table-cell-comfortable",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Padding/card-padding-compact",
            "value": "1rem",
            "var": "System Spacing/spacing-sm",
            "rootAlias": "System Spacing/spacing-sm"
          },
          {
            "name": "Padding/card-padding-default",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Padding/table-cell-first",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "System Spacing/spacing-none",
            "value": "0rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxxs",
            "value": "0.25rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxs",
            "value": "0.5rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xs",
            "value": "0.75rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-sm",
            "value": "1rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-md",
            "value": "1.5rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-lg",
            "value": "2rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xl",
            "value": "3rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxl",
            "value": "4rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxxl",
            "value": "6rem",
            "var": "",
            "rootAlias": ""
          }
        ]
      },
      {
        "mode": {
          "name": "Desktop",
          "id": "3062:8"
        },
        "color": [],
        "number": [
          {
            "name": "Margins/Component Level/bottom-none",
            "value": "0rem",
            "var": "System Spacing/spacing-none",
            "rootAlias": "System Spacing/spacing-none"
          },
          {
            "name": "Margins/Component Level/horizontal-tight",
            "value": "0.25rem",
            "var": "System Spacing/spacing-xxxs",
            "rootAlias": "System Spacing/spacing-xxxs"
          },
          {
            "name": "Margins/Component Level/horizontal-default",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Margins/Component Level/top-tight",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Margins/Component Level/vertical-cards",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Margins/Component Level/horizontal-comfortable",
            "value": "1rem",
            "var": "System Spacing/spacing-sm",
            "rootAlias": "System Spacing/spacing-sm"
          },
          {
            "name": "Margins/Component Level/top-dense",
            "value": "1rem",
            "var": "System Spacing/spacing-sm",
            "rootAlias": "System Spacing/spacing-sm"
          },
          {
            "name": "Margins/Component Level/vertical-inputs",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Margins/Component Level/top-default",
            "value": "2rem",
            "var": "System Spacing/spacing-lg",
            "rootAlias": "System Spacing/spacing-lg"
          },
          {
            "name": "Margins/Component Level/component-grid",
            "value": "3rem",
            "var": "System Spacing/spacing-xl",
            "rootAlias": "System Spacing/spacing-xl"
          },
          {
            "name": "Margins/Page Level/top-page",
            "value": "0rem",
            "var": "System Spacing/spacing-none",
            "rootAlias": "System Spacing/spacing-none"
          },
          {
            "name": "Margins/Page Level/left-page",
            "value": "3rem",
            "var": "System Spacing/spacing-xl",
            "rootAlias": "System Spacing/spacing-xl"
          },
          {
            "name": "Margins/Page Level/right-page",
            "value": "3rem",
            "var": "System Spacing/spacing-xl",
            "rootAlias": "System Spacing/spacing-xl"
          },
          {
            "name": "Margins/Page Level/bottom-page",
            "value": "6rem",
            "var": "System Spacing/spacing-xxxl",
            "rootAlias": "System Spacing/spacing-xxxl"
          },
          {
            "name": "Margins/Page Level/focus-page",
            "value": "15rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "Padding/component-compact",
            "value": "0.25rem",
            "var": "System Spacing/spacing-xxxs",
            "rootAlias": "System Spacing/spacing-xxxs"
          },
          {
            "name": "Padding/table-cell-compact",
            "value": "0.25rem",
            "var": "System Spacing/spacing-xxxs",
            "rootAlias": "System Spacing/spacing-xxxs"
          },
          {
            "name": "Padding/component-default",
            "value": "0.5rem",
            "var": "System Spacing/spacing-xxs",
            "rootAlias": "System Spacing/spacing-xxs"
          },
          {
            "name": "Padding/icon-text-padding",
            "value": "0.5rem",
            "var": "System Spacing/spacing-xxs",
            "rootAlias": "System Spacing/spacing-xxs"
          },
          {
            "name": "Padding/table-cell-default",
            "value": "0.5rem",
            "var": "System Spacing/spacing-xxs",
            "rootAlias": "System Spacing/spacing-xxs"
          },
          {
            "name": "Padding/component-comfortable",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Padding/table-cell-comfortable",
            "value": "0.75rem",
            "var": "System Spacing/spacing-xs",
            "rootAlias": "System Spacing/spacing-xs"
          },
          {
            "name": "Padding/card-padding-compact",
            "value": "1rem",
            "var": "System Spacing/spacing-sm",
            "rootAlias": "System Spacing/spacing-sm"
          },
          {
            "name": "Padding/card-padding-default",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "Padding/table-cell-first",
            "value": "1.5rem",
            "var": "System Spacing/spacing-md",
            "rootAlias": "System Spacing/spacing-md"
          },
          {
            "name": "System Spacing/spacing-none",
            "value": "0rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxxs",
            "value": "0.25rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxs",
            "value": "0.5rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xs",
            "value": "0.75rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-sm",
            "value": "1rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-md",
            "value": "1.5rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-lg",
            "value": "2rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xl",
            "value": "3rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxl",
            "value": "4rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "System Spacing/spacing-xxxl",
            "value": "6rem",
            "var": "",
            "rootAlias": ""
          }
        ]
      }
    ]
  },
  {
    "name": "Style Tokens",
    "values": [
      {
        "mode": {
          "name": "Mode 1",
          "id": "1462:6"
        },
        "color": [],
        "number": [
          {
            "name": "input-radius",
            "value": "0.25rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "chip-radius",
            "value": "0.5rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "card-radius",
            "value": "0.75rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "modal-radius",
            "value": "1rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "Column Widths/column-sm",
            "value": "5rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "Column Widths/column-md",
            "value": "7.5rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "Column Widths/column-lg",
            "value": "10rem",
            "var": "",
            "rootAlias": ""
          }
        ]
      }
    ]
  },
  {
    "name": "Themes",
    "values": [
      {
        "mode": {
          "name": "Light",
          "id": "2793:0"
        },
        "color": [
          {
            "name": "black",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "white",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/NeutralDarkFixed/brand/color",
            "color": "#000000cc",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/NeutralDarkFixed/brand/on-color",
            "color": "#f6f6f6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGAFamilyGolf/brand/color",
            "color": "#49c5b1",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGAFamilyGolf/brand/color-logo",
            "color": "#00afb6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGAFamilyGolf/brand/color-secondary",
            "color": "#ff7500",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGAFamilyGolf/brand/on-color",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGAJrLeague/brand/color",
            "color": "#0077c8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGAJrLeague/brand/color-secondary",
            "color": "#ff7500",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGAJrLeague/brand/on-color",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGADarkNavy/brand/color",
            "color": "#001123",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGADarkNavy/brand/color-bright",
            "color": "#00234B",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGADarkNavy/brand/on-color",
            "color": "#EBEFF5",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGASilver/brand/color",
            "color": "#EBEFF5",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGASilver/brand/on-color",
            "color": "#00234B",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGASilver/brand/color-opacity-20",
            "color": "#EBEFF533",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGASilver/brand/color-opacity-60",
            "color": "#EBEFF599",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/table/sticky-column-hover",
            "color": "#F8F9FD",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/table/sticky-column-highlight",
            "color": "#F3F5F9",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/highlight/brand/color",
            "color": "#E6BC5A",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/highlight/brand/on-color",
            "color": "#FFFFFF",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGALogo/brand/color",
            "color": "#00205b",
            "var": "extended/PGANavy/brand/color",
            "rootAlias": "extended/PGANavy/brand/color"
          },
          {
            "name": "extended/PGALogo/brand/tertiary-color",
            "color": "#ab9157",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/seed",
            "color": "#00205b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/value",
            "color": "#00205b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/brand/color",
            "color": "#00205b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/brand/color-bright",
            "color": "#48A7F8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/brand/color-container",
            "color": "#ccddff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/brand/color-container-bright",
            "color": "#d8f4ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/brand/on-color",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/brand/on-color-container",
            "color": "#00205b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone10",
            "color": "#001849",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone15",
            "color": "#00215e",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone20",
            "color": "#002b74",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone25",
            "color": "#0f3683",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone30",
            "color": "#20428f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone35",
            "color": "#2e4e9c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone40",
            "color": "#3b5ba9",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone5",
            "color": "#000e32",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone50",
            "color": "#5674c4",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone60",
            "color": "#708ee0",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone70",
            "color": "#8ba9fc",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone80",
            "color": "#b2c5ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone90",
            "color": "#dae2ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone95",
            "color": "#eef0ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone98",
            "color": "#faf8ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone99",
            "color": "#fefbff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/seed",
            "color": "#0cb157",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/value",
            "color": "#0cb157",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/brand/color",
            "color": "#0cb157",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/brand/color-container",
            "color": "#BEF1BB",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/brand/on-color",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/brand/on-color-container",
            "color": "#00210b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone10",
            "color": "#00210b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone15",
            "color": "#002d11",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone20",
            "color": "#003917",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone25",
            "color": "#00461e",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone30",
            "color": "#005224",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone35",
            "color": "#00602b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone40",
            "color": "#006d33",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone5",
            "color": "#001505",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone50",
            "color": "#008a41",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone60",
            "color": "#00a751",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone70",
            "color": "#31c367",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone80",
            "color": "#54e07f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone90",
            "color": "#73fd99",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone95",
            "color": "#c4ffcb",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone98",
            "color": "#eaffe9",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone99",
            "color": "#f5fff2",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/seed",
            "color": "#ffb323",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/value",
            "color": "#ffb323",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/brand/color",
            "color": "#FFBB4B",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/brand/color-container",
            "color": "#ffddaf",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/brand/color-container-bright",
            "color": "#FFE5BA",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/brand/on-color",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/brand/on-color-container",
            "color": "#281800",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone10",
            "color": "#281800",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone15",
            "color": "#362200",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone20",
            "color": "#442c00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone25",
            "color": "#523600",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone30",
            "color": "#614000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone35",
            "color": "#704b00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone40",
            "color": "#805600",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone5",
            "color": "#1a0f00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone50",
            "color": "#a06d00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone60",
            "color": "#c28500",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone70",
            "color": "#e59d00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone80",
            "color": "#ffba44",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone90",
            "color": "#ffddaf",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone95",
            "color": "#ffeedb",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone98",
            "color": "#fff8f3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone99",
            "color": "#fffbff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "key-colors/error",
            "color": "#ff5247",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "key-colors/neutral",
            "color": "#f7f9fa",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "key-colors/neutral-variant",
            "color": "#b9cbd3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "key-colors/primary",
            "color": "#0053ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "key-colors/secondary",
            "color": "#00205b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "key-colors/tertiary",
            "color": "#c5a561",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error10",
            "color": "#410002",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error12",
            "color": "#490002",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error17",
            "color": "#5c0004",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error20",
            "color": "#690005",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error22",
            "color": "#710006",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error24",
            "color": "#790006",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error25",
            "color": "#7e0007",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error30",
            "color": "#93000a",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error35",
            "color": "#a70c12",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error4",
            "color": "#280001",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error40",
            "color": "#b91d1c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error5",
            "color": "#2d0001",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error50",
            "color": "#dc3932",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error6",
            "color": "#310001",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error60",
            "color": "#ff5449",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error70",
            "color": "#ff897d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error80",
            "color": "#ffb4ab",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error87",
            "color": "#ffcfc9",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error90",
            "color": "#ffdad6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error92",
            "color": "#ffe2de",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error94",
            "color": "#ffe9e6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error95",
            "color": "#ffedea",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error96",
            "color": "#fff0ee",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error98",
            "color": "#fff8f7",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error99",
            "color": "#fffbff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral10",
            "color": "#111111",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral12",
            "color": "#1f1f1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral17",
            "color": "#2b2b2b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral20",
            "color": "#2d2d2d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral22",
            "color": "#333333",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral24",
            "color": "#3d3d3d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral25",
            "color": "#404040",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral30",
            "color": "#494949",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral35",
            "color": "#595959",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral4",
            "color": "#020202",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral40",
            "color": "#656565",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral5",
            "color": "#0d0d0d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral50",
            "color": "#818181",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral6",
            "color": "#0a0a0a",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral60",
            "color": "#9d9d9d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral70",
            "color": "#b9b9b9",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral80",
            "color": "#d5d5d5",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral87",
            "color": "#e8e8e8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral90",
            "color": "#f1f1f1",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral92",
            "color": "#f3f3f3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral94",
            "color": "#f5f5f5",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral95",
            "color": "#f6f6f6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral96",
            "color": "#f7f7f7",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral98",
            "color": "#fcfcfc",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral99",
            "color": "#fefefe",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant10",
            "color": "#151d20",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant12",
            "color": "#192124",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant17",
            "color": "#232b2f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant20",
            "color": "#2a3235",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant22",
            "color": "#2e3639",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant24",
            "color": "#323a3e",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant25",
            "color": "#343d40",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant30",
            "color": "#40484c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant35",
            "color": "#4b5457",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant4",
            "color": "#070f12",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant40",
            "color": "#576063",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant5",
            "color": "#0a1215",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant50",
            "color": "#70787c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant6",
            "color": "#0c1518",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant60",
            "color": "#8a9296",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant70",
            "color": "#a4acb1",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant80",
            "color": "#bfc8cc",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant87",
            "color": "#d3dbe0",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant90",
            "color": "#dbe4e8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant92",
            "color": "#e1e9ee",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant94",
            "color": "#e7eff3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant95",
            "color": "#eaf2f6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant96",
            "color": "#edf5f9",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant98",
            "color": "#f2fbff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant99",
            "color": "#f9fdff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary10",
            "color": "#001c57",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary12",
            "color": "#00185b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary17",
            "color": "#002173",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary20",
            "color": "#002e8f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary22",
            "color": "#002a8c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary24",
            "color": "#002d96",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary25",
            "color": "#002f9b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary30",
            "color": "#0041c7",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary35",
            "color": "#0042d0",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary4",
            "color": "#000a33",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary40",
            "color": "#0053ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary5",
            "color": "#000c39",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary50",
            "color": "#296fff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary6",
            "color": "#000e3f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary60",
            "color": "#528aff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary70",
            "color": "#7aa6ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary87",
            "color": "#d1d8ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary90",
            "color": "#ccddff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary92",
            "color": "#e4e7ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary94",
            "color": "#ebedff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary95",
            "color": "#e0eaff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary96",
            "color": "#f3f2ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary98",
            "color": "#faf8ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary99",
            "color": "#fcfdfd",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary10",
            "color": "#172024",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary12",
            "color": "#001c51",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary17",
            "color": "#002567",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary20",
            "color": "#2d3f47",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary22",
            "color": "#012f7d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary24",
            "color": "#0a3481",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary25",
            "color": "#0f3683",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary30",
            "color": "#425d69",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary35",
            "color": "#2e4e9c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary4",
            "color": "#000c2d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary40",
            "color": "#587c8c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary5",
            "color": "#000e32",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary50",
            "color": "#7498a8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary6",
            "color": "#001037",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary60",
            "color": "#97b1bd",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary70",
            "color": "#b9cbd3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary80",
            "color": "#d2dee3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary87",
            "color": "#ced9ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary90",
            "color": "#ebf0f2",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary92",
            "color": "#e2e7ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary94",
            "color": "#eaedff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary95",
            "color": "#eff3f5",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary96",
            "color": "#f2f3ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary98",
            "color": "#faf8ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary99",
            "color": "#fcfdfd",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary10",
            "color": "#5c4922",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary12",
            "color": "#2b1d00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary17",
            "color": "#372700",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary20",
            "color": "#856a31",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary22",
            "color": "#453200",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary24",
            "color": "#4a3600",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary25",
            "color": "#4d3800",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary30",
            "color": "#ae8b40",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary35",
            "color": "#6a4e00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary4",
            "color": "#150d00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary40",
            "color": "#c5a561",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary5",
            "color": "#180f00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary50",
            "color": "#d0b67f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary6",
            "color": "#1b1200",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary60",
            "color": "#dbc79d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary70",
            "color": "#e6d8bb",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary80",
            "color": "#f1e9d8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary87",
            "color": "#ffd579",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary90",
            "color": "#fcfaf6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary92",
            "color": "#ffe5b4",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary94",
            "color": "#ffecca",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary95",
            "color": "#fefdfb",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary96",
            "color": "#fff2de",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary98",
            "color": "#fff8f2",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary99",
            "color": "#fefdfb",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "source/seed",
            "color": "#0053ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/background/opacity-0-08",
            "color": "#fbfcfd14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/background/opacity-0-12",
            "color": "#fbfcfd1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/background/opacity-0-16",
            "color": "#fbfcfd29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/error/opacity-0-08",
            "color": "#b91d1c14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/error/opacity-0-12",
            "color": "#b91d1c1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/error/opacity-0-16",
            "color": "#b91d1c29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/error-container/opacity-0-08",
            "color": "#ffdad614",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/error-container/opacity-0-12",
            "color": "#ffdad61f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/error-container/opacity-0-16",
            "color": "#ffdad629",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-on-surface/opacity-0-08",
            "color": "#eff1f214",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-on-surface/opacity-0-12",
            "color": "#eff1f21f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-on-surface/opacity-0-16",
            "color": "#eff1f229",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-primary/opacity-0-08",
            "color": "#b7c4ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-primary/opacity-0-12",
            "color": "#b7c4ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-primary/opacity-0-16",
            "color": "#b7c4ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-surface/opacity-0-08",
            "color": "#2e313214",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-surface/opacity-0-12",
            "color": "#2e31321f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-surface/opacity-0-16",
            "color": "#2e313229",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-background/opacity-0-08",
            "color": "#191c1d14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-background/opacity-0-12",
            "color": "#191c1d1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-background/opacity-0-16",
            "color": "#191c1d29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-error/opacity-0-08",
            "color": "#ffffff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-error/opacity-0-12",
            "color": "#ffffff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-error/opacity-0-16",
            "color": "#ffffff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-error-container/opacity-0-08",
            "color": "#41000214",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-error-container/opacity-0-12",
            "color": "#4100021f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-error-container/opacity-0-16",
            "color": "#41000229",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary/opacity-0-08",
            "color": "#ffffff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary/opacity-0-12",
            "color": "#ffffff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary/opacity-0-16",
            "color": "#ffffff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary/opacity-0-72",
            "color": "#ffffffb8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-container/opacity-0-08",
            "color": "#00155114",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-container/opacity-0-12",
            "color": "#0015511f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-container/opacity-0-16",
            "color": "#00155129",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-fixed/opacity-0-08",
            "color": "#00155114",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-fixed/opacity-0-12",
            "color": "#0015511f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-fixed/opacity-0-16",
            "color": "#00155129",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-fixed-variant/opacity-0-08",
            "color": "#0039b514",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-fixed-variant/opacity-0-12",
            "color": "#0039b51f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-fixed-variant/opacity-0-16",
            "color": "#0039b529",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary/opacity-0-08",
            "color": "#ffffff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary/opacity-0-12",
            "color": "#ffffff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary/opacity-0-16",
            "color": "#ffffff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-container/opacity-0-08",
            "color": "#00184914",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-container/opacity-0-12",
            "color": "#0018491f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-container/opacity-0-16",
            "color": "#00184929",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-fixed/opacity-0-08",
            "color": "#00184914",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-fixed/opacity-0-12",
            "color": "#0018491f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-fixed/opacity-0-16",
            "color": "#00184929",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-fixed-variant/opacity-0-08",
            "color": "#20428f14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-fixed-variant/opacity-0-12",
            "color": "#20428f1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-fixed-variant/opacity-0-16",
            "color": "#20428f29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-surface/opacity-0-08",
            "color": "#191c1d14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-surface/opacity-0-12",
            "color": "#191c1d1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-surface/opacity-0-16",
            "color": "#191c1d1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-surface-variant/opacity-0-08",
            "color": "#40484c14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-surface-variant/opacity-0-12",
            "color": "#40484c1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-surface-variant/opacity-0-16",
            "color": "#40484c29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary/opacity-0-08",
            "color": "#ffffff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary/opacity-0-12",
            "color": "#ffffff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary/opacity-0-16",
            "color": "#ffffff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-container/opacity-0-08",
            "color": "#261a0014",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-container/opacity-0-12",
            "color": "#261a001f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-container/opacity-0-16",
            "color": "#261a0029",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-fixed/opacity-0-08",
            "color": "#261a0014",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-fixed/opacity-0-12",
            "color": "#261a001f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-fixed/opacity-0-16",
            "color": "#261a0029",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-fixed-variant/opacity-0-08",
            "color": "#5b430014",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-fixed-variant/opacity-0-12",
            "color": "#5b43001f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-fixed-variant/opacity-0-16",
            "color": "#5b430029",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/outline/opacity-0-08",
            "color": "#70787c14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/outline/opacity-0-12",
            "color": "#70787c1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/outline/opacity-0-16",
            "color": "#70787c29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/outline-variant/opacity-0-08",
            "color": "#bfc8cc14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/outline-variant/opacity-0-12",
            "color": "#bfc8cc1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/outline-variant/opacity-0-16",
            "color": "#bfc8cc29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary/opacity-0-08",
            "color": "#004cec14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary/opacity-0-12",
            "color": "#004cec1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary/opacity-0-16",
            "color": "#004cec29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-container/opacity-0-08",
            "color": "#dce1ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-container/opacity-0-12",
            "color": "#dce1ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-container/opacity-0-16",
            "color": "#dce1ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-fixed/opacity-0-08",
            "color": "#dce1ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-fixed/opacity-0-12",
            "color": "#dce1ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-fixed/opacity-0-16",
            "color": "#dce1ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-fixed-dim/opacity-0-08",
            "color": "#b7c4ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-fixed-dim/opacity-0-12",
            "color": "#b7c4ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-fixed-dim/opacity-0-16",
            "color": "#b7c4ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/scrim/opacity-0-08",
            "color": "#00000014",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/scrim/opacity-0-12",
            "color": "#0000001f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/scrim/opacity-0-16",
            "color": "#00000029",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary/opacity-0-08",
            "color": "#3b5ba914",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary/opacity-0-12",
            "color": "#3b5ba91f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary/opacity-0-16",
            "color": "#3b5ba929",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-container/opacity-0-08",
            "color": "#dae2ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-container/opacity-0-12",
            "color": "#dae2ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-container/opacity-0-16",
            "color": "#dae2ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-fixed/opacity-0-08",
            "color": "#dae2ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-fixed/opacity-0-12",
            "color": "#dae2ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-fixed/opacity-0-16",
            "color": "#dae2ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-fixed-dim/opacity-0-08",
            "color": "#b2c5ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-fixed-dim/opacity-0-12",
            "color": "#b2c5ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-fixed-dim/opacity-0-16",
            "color": "#b2c5ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/shadow/opacity-0-08",
            "color": "#00000014",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/shadow/opacity-0-12",
            "color": "#0000001f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/shadow/opacity-0-16",
            "color": "#00000029",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface/opacity-0-08",
            "color": "#f8fafa14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface/opacity-0-12",
            "color": "#f8fafa1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface/opacity-0-16",
            "color": "#f8fafa29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-bright/opacity-0-08",
            "color": "#f8fafa14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-bright/opacity-0-12",
            "color": "#f8fafa1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-bright/opacity-0-16",
            "color": "#f8fafa29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container/opacity-0-08",
            "color": "#eceeef14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container/opacity-0-12",
            "color": "#eceeef1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container/opacity-0-16",
            "color": "#eceeef29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-high/opacity-0-08",
            "color": "#e6e8e914",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-high/opacity-0-12",
            "color": "#e6e8e91f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-high/opacity-0-16",
            "color": "#e6e8e929",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-highest/opacity-0-08",
            "color": "#e1e3e414",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-highest/opacity-0-12",
            "color": "#e1e3e41f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-highest/opacity-0-16",
            "color": "#e1e3e429",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-low/opacity-0-08",
            "color": "#f2f4f514",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-low/opacity-0-12",
            "color": "#f2f4f51f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-low/opacity-0-16",
            "color": "#f2f4f529",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-lowest/opacity-0-08",
            "color": "#ffffff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-lowest/opacity-0-12",
            "color": "#ffffff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-lowest/opacity-0-16",
            "color": "#ffffff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-dim/opacity-0-08",
            "color": "#d8dadb14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-dim/opacity-0-12",
            "color": "#d8dadb1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-dim/opacity-0-16",
            "color": "#d8dadb29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-tint/opacity-0-08",
            "color": "#004cec14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-tint/opacity-0-12",
            "color": "#004cec1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-tint/opacity-0-16",
            "color": "#004cec29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-variant/opacity-0-08",
            "color": "#dbe4e814",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-variant/opacity-0-12",
            "color": "#dbe4e81f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-variant/opacity-0-16",
            "color": "#dbe4e829",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary/opacity-0-08",
            "color": "#79590014",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary/opacity-0-12",
            "color": "#7959001f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary/opacity-0-16",
            "color": "#79590029",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-container/opacity-0-08",
            "color": "#ffdf9e14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-container/opacity-0-12",
            "color": "#ffdf9e1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-container/opacity-0-16",
            "color": "#ffdf9e29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-fixed/opacity-0-08",
            "color": "#ffdf9e14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-fixed/opacity-0-12",
            "color": "#ffdf9e1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-fixed/opacity-0-16",
            "color": "#ffdf9e29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-fixed-dim/opacity-0-08",
            "color": "#f2bf4814",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-fixed-dim/opacity-0-12",
            "color": "#f2bf481f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-fixed-dim/opacity-0-16",
            "color": "#f2bf4829",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/background",
            "color": "#fbfcfd",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/error",
            "color": "#FF5247",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/error-container",
            "color": "#FFBCBC",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/inverse-on-surface",
            "color": "#f6f6f6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/inverse-primary",
            "color": "#a3c1ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/inverse-surface",
            "color": "#2d2d2d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-background",
            "color": "#191c1d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-error",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-error-container",
            "color": "#410002",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-primary",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-primary-container",
            "color": "#001c57",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-primary-fixed",
            "color": "#001c57",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-primary-fixed-variant",
            "color": "#0041c7",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-secondary",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-secondary-container",
            "color": "#172024",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-secondary-fixed",
            "color": "#172024",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-secondary-fixed-variant",
            "color": "#425d69",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-surface",
            "color": "#111111",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-surface-variant",
            "color": "#40484c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-tertiary",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-tertiary-container",
            "color": "#5c4922",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-tertiary-fixed",
            "color": "#5c4922",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-tertiary-fixed-variant",
            "color": "#ae8b40",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/outline",
            "color": "#70787c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/outline-variant",
            "color": "#bfc8cc",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/primary",
            "color": "#0053ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/primary-container",
            "color": "#ccddff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/primary-container-bright",
            "color": "#e0eaff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/primary-fixed",
            "color": "#ccddff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/primary-fixed-dim",
            "color": "#a3c1ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/scrim",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/secondary",
            "color": "#587c8c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/secondary-container",
            "color": "#ebf0f2",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/secondary-fixed",
            "color": "#ebf0f2",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/secondary-fixed-dim",
            "color": "#d2dee3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/shadow",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-bright",
            "color": "#fcfcfc",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-container",
            "color": "#fcfcfc",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-container-high",
            "color": "#f3f3f3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-container-highest",
            "color": "#f1f1f1",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-container-low",
            "color": "#fefefe",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-container-lowest",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-dim",
            "color": "#e8e8e8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-tint",
            "color": "#004cec",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-variant",
            "color": "#dbe4e8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/tertiary",
            "color": "#c5a561",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/tertiary-container",
            "color": "#fcfaf6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/tertiary-fixed",
            "color": "#fcfaf6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/tertiary-fixed-dim",
            "color": "#f1e9d8",
            "var": "",
            "rootAlias": ""
          }
        ],
        "number": []
      },
      {
        "mode": {
          "name": "Dark",
          "id": "2793:1"
        },
        "color": [
          {
            "name": "black",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "white",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/NeutralDarkFixed/brand/color",
            "color": "#000000cc",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/NeutralDarkFixed/brand/on-color",
            "color": "#f6f6f6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGAFamilyGolf/brand/color",
            "color": "#49c5b1",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGAFamilyGolf/brand/color-logo",
            "color": "#00afb6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGAFamilyGolf/brand/color-secondary",
            "color": "#ff7500",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGAFamilyGolf/brand/on-color",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGAJrLeague/brand/color",
            "color": "#4698ca",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGAJrLeague/brand/color-secondary",
            "color": "#ff7500",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGAJrLeague/brand/on-color",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGALogo/brand/color",
            "color": "#ffffff",
            "var": "white",
            "rootAlias": "white"
          },
          {
            "name": "extended/PGALogo/brand/tertiary-color",
            "color": "#ab9157",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGADarkNavy/brand/color",
            "color": "#E1E4E7",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGADarkNavy/brand/color-bright",
            "color": "#E3E7EC",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGADarkNavy/brand/on-color",
            "color": "#00234B",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGASilver/brand/color",
            "color": "#1d2021",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGASilver/brand/on-color",
            "color": "#EBEFF5",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/table/sticky-column-hover",
            "color": "#373839",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/highlight/brand/color",
            "color": "#E6BC5A",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/highlight/brand/on-color",
            "color": "#442c00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/seed",
            "color": "#00205b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/value",
            "color": "#00205b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/brand/color",
            "color": "#0041c7",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/brand/color-bright",
            "color": "#48A7F8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/brand/color-container",
            "color": "#20428f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/brand/color-container-bright",
            "color": "#20428f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/brand/on-color",
            "color": "#00205b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/brand/on-color-container",
            "color": "#dae2ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone10",
            "color": "#001849",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone15",
            "color": "#00215e",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone20",
            "color": "#002b74",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone25",
            "color": "#0f3683",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone30",
            "color": "#20428f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone35",
            "color": "#2e4e9c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone40",
            "color": "#3b5ba9",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone5",
            "color": "#000e32",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone50",
            "color": "#5674c4",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone60",
            "color": "#708ee0",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone70",
            "color": "#8ba9fc",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone80",
            "color": "#b2c5ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone90",
            "color": "#dae2ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone95",
            "color": "#eef0ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone98",
            "color": "#faf8ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/PGANavy/group/tone99",
            "color": "#fefbff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/seed",
            "color": "#0cb157",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/value",
            "color": "#0cb157",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/brand/color",
            "color": "#54e07f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/brand/color-container",
            "color": "#005224",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/brand/on-color",
            "color": "#003917",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/brand/on-color-container",
            "color": "#73fd99",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone10",
            "color": "#00210b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone15",
            "color": "#002d11",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone20",
            "color": "#003917",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone25",
            "color": "#00461e",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone30",
            "color": "#005224",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone35",
            "color": "#00602b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone40",
            "color": "#006d33",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone5",
            "color": "#001505",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone50",
            "color": "#008a41",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone60",
            "color": "#00a751",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone70",
            "color": "#31c367",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone80",
            "color": "#54e07f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone90",
            "color": "#73fd99",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone95",
            "color": "#c4ffcb",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone98",
            "color": "#eaffe9",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Success/group/tone99",
            "color": "#f5fff2",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/seed",
            "color": "#ffb323",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/value",
            "color": "#ffb323",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/brand/color",
            "color": "#ffba44",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/brand/color-container",
            "color": "#614000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/brand/color-container-bright",
            "color": "#FFE5BA",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/brand/on-color",
            "color": "#442c00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/brand/on-color-container",
            "color": "#ffddaf",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone10",
            "color": "#281800",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone15",
            "color": "#362200",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone20",
            "color": "#442c00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone25",
            "color": "#523600",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone30",
            "color": "#614000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone35",
            "color": "#704b00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone40",
            "color": "#805600",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone5",
            "color": "#1a0f00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone50",
            "color": "#a06d00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone60",
            "color": "#c28500",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone70",
            "color": "#e59d00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone80",
            "color": "#ffba44",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone90",
            "color": "#ffddaf",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone95",
            "color": "#ffeedb",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone98",
            "color": "#fff8f3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "extended/Warning/group/tone99",
            "color": "#fffbff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "key-colors/error",
            "color": "#ff5247",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "key-colors/neutral",
            "color": "#f7f9fa",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "key-colors/neutral-variant",
            "color": "#b9cbd3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "key-colors/primary",
            "color": "#0053ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "key-colors/secondary",
            "color": "#00205b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "key-colors/tertiary",
            "color": "#c5a561",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error10",
            "color": "#410002",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error12",
            "color": "#490002",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error17",
            "color": "#5c0004",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error20",
            "color": "#690005",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error22",
            "color": "#710006",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error24",
            "color": "#790006",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error25",
            "color": "#7e0007",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error30",
            "color": "#93000a",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error35",
            "color": "#a70c12",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error4",
            "color": "#280001",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error40",
            "color": "#b91d1c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error5",
            "color": "#2d0001",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error50",
            "color": "#dc3932",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error6",
            "color": "#310001",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error60",
            "color": "#ff5449",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error70",
            "color": "#ff897d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error80",
            "color": "#ffb4ab",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error87",
            "color": "#ffcfc9",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error90",
            "color": "#ffdad6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error92",
            "color": "#ffe2de",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error94",
            "color": "#ffe9e6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error95",
            "color": "#ffedea",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error96",
            "color": "#fff0ee",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error98",
            "color": "#fff8f7",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/error/error99",
            "color": "#fffbff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral10",
            "color": "#111111",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral12",
            "color": "#1f1f1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral17",
            "color": "#2b2b2b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral20",
            "color": "#2d2d2d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral22",
            "color": "#333333",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral24",
            "color": "#3d3d3d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral25",
            "color": "#404040",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral30",
            "color": "#494949",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral35",
            "color": "#595959",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral4",
            "color": "#020202",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral40",
            "color": "#656565",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral5",
            "color": "#0d0d0d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral50",
            "color": "#818181",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral6",
            "color": "#0a0a0a",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral60",
            "color": "#9d9d9d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral70",
            "color": "#b9b9b9",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral80",
            "color": "#d5d5d5",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral87",
            "color": "#e8e8e8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral90",
            "color": "#f1f1f1",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral92",
            "color": "#f3f3f3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral94",
            "color": "#f5f5f5",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral95",
            "color": "#f6f6f6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral96",
            "color": "#f7f7f7",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral98",
            "color": "#fcfcfc",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral/neutral99",
            "color": "#fefefe",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant10",
            "color": "#151d20",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant12",
            "color": "#192124",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant17",
            "color": "#232b2f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant20",
            "color": "#2a3235",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant22",
            "color": "#2e3639",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant24",
            "color": "#323a3e",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant25",
            "color": "#343d40",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant30",
            "color": "#40484c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant35",
            "color": "#4b5457",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant4",
            "color": "#070f12",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant40",
            "color": "#576063",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant5",
            "color": "#0a1215",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant50",
            "color": "#70787c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant6",
            "color": "#0c1518",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant60",
            "color": "#8a9296",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant70",
            "color": "#a4acb1",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant80",
            "color": "#bfc8cc",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant87",
            "color": "#d3dbe0",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant90",
            "color": "#dbe4e8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant92",
            "color": "#e1e9ee",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant94",
            "color": "#e7eff3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant95",
            "color": "#eaf2f6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant96",
            "color": "#edf5f9",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant98",
            "color": "#f2fbff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/neutral-variant/neutral-variant99",
            "color": "#f9fdff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary10",
            "color": "#001c57",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary12",
            "color": "#00185b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary17",
            "color": "#002173",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary20",
            "color": "#002e8f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary22",
            "color": "#002a8c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary24",
            "color": "#002d96",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary25",
            "color": "#002f9b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary30",
            "color": "#0041c7",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary35",
            "color": "#0042d0",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary4",
            "color": "#000a33",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary40",
            "color": "#0053ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary5",
            "color": "#000c39",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary50",
            "color": "#296fff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary6",
            "color": "#000e3f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary60",
            "color": "#528aff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary70",
            "color": "#7aa6ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary87",
            "color": "#d1d8ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary90",
            "color": "#ccddff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary92",
            "color": "#e4e7ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary94",
            "color": "#ebedff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary95",
            "color": "#e0eaff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary96",
            "color": "#f3f2ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary98",
            "color": "#faf8ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/primary/primary99",
            "color": "#fcfdfd",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary10",
            "color": "#172024",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary12",
            "color": "#001c51",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary17",
            "color": "#002567",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary20",
            "color": "#2d3f47",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary22",
            "color": "#012f7d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary24",
            "color": "#0a3481",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary25",
            "color": "#0f3683",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary30",
            "color": "#425d69",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary35",
            "color": "#2e4e9c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary4",
            "color": "#000c2d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary40",
            "color": "#587c8c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary5",
            "color": "#000e32",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary50",
            "color": "#7498a8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary6",
            "color": "#001037",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary60",
            "color": "#97b1bd",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary70",
            "color": "#b9cbd3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary80",
            "color": "#d2dee3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary87",
            "color": "#ced9ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary90",
            "color": "#ebf0f2",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary92",
            "color": "#e2e7ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary94",
            "color": "#eaedff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary95",
            "color": "#eff3f5",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary96",
            "color": "#f2f3ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary98",
            "color": "#faf8ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/secondary/secondary99",
            "color": "#fcfdfd",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary0",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary10",
            "color": "#5c4922",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary100",
            "color": "#ffffff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary12",
            "color": "#2b1d00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary17",
            "color": "#372700",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary20",
            "color": "#856a31",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary22",
            "color": "#453200",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary24",
            "color": "#4a3600",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary25",
            "color": "#4d3800",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary30",
            "color": "#ae8b40",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary35",
            "color": "#6a4e00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary4",
            "color": "#150d00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary40",
            "color": "#c5a561",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary5",
            "color": "#180f00",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary50",
            "color": "#d0b67f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary6",
            "color": "#1b1200",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary60",
            "color": "#dbc79d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary70",
            "color": "#e6d8bb",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary80",
            "color": "#f1e9d8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary87",
            "color": "#ffd579",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary90",
            "color": "#fcfaf6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary92",
            "color": "#ffe5b4",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary94",
            "color": "#ffecca",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary95",
            "color": "#fefdfb",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary96",
            "color": "#fff2de",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary98",
            "color": "#fff8f2",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "ref/tertiary/tertiary99",
            "color": "#fefdfb",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "source/seed",
            "color": "#0053ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/background/opacity-0-08",
            "color": "#191c1d14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/background/opacity-0-12",
            "color": "#191c1d1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/background/opacity-0-16",
            "color": "#191c1d29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/error/opacity-0-08",
            "color": "#ffb4ab14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/error/opacity-0-12",
            "color": "#ffb4ab1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/error/opacity-0-16",
            "color": "#ffb4ab29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/error-container/opacity-0-08",
            "color": "#93000a14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/error-container/opacity-0-12",
            "color": "#93000a1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/error-container/opacity-0-16",
            "color": "#93000a29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-on-surface/opacity-0-08",
            "color": "#191c1d14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-on-surface/opacity-0-12",
            "color": "#191c1d1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-on-surface/opacity-0-16",
            "color": "#191c1d29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-primary/opacity-0-08",
            "color": "#004cec14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-primary/opacity-0-12",
            "color": "#004cec1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-primary/opacity-0-16",
            "color": "#004cec29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-surface/opacity-0-08",
            "color": "#e1e3e414",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-surface/opacity-0-12",
            "color": "#e1e3e41f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/inverse-surface/opacity-0-16",
            "color": "#e1e3e429",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-background/opacity-0-08",
            "color": "#e1e3e414",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-background/opacity-0-12",
            "color": "#e1e3e41f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-background/opacity-0-16",
            "color": "#e1e3e429",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-error/opacity-0-08",
            "color": "#69000514",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-error/opacity-0-12",
            "color": "#6900051f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-error/opacity-0-16",
            "color": "#69000529",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-error-container/opacity-0-08",
            "color": "#ffdad614",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-error-container/opacity-0-12",
            "color": "#ffdad61f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-error-container/opacity-0-16",
            "color": "#ffdad629",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary/opacity-0-08",
            "color": "#00268214",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary/opacity-0-12",
            "color": "#0026821f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary/opacity-0-16",
            "color": "#00268229",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary/opacity-0-72",
            "color": "#002682b8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-container/opacity-0-08",
            "color": "#dce1ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-container/opacity-0-12",
            "color": "#dce1ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-container/opacity-0-16",
            "color": "#dce1ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-fixed/opacity-0-08",
            "color": "#00155114",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-fixed/opacity-0-12",
            "color": "#0015511f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-fixed/opacity-0-16",
            "color": "#00155129",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-fixed-variant/opacity-0-08",
            "color": "#0039b514",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-fixed-variant/opacity-0-12",
            "color": "#0039b51f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-primary-fixed-variant/opacity-0-16",
            "color": "#0039b529",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary/opacity-0-08",
            "color": "#002b7414",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary/opacity-0-12",
            "color": "#002b741f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary/opacity-0-16",
            "color": "#002b7429",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-container/opacity-0-08",
            "color": "#dae2ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-container/opacity-0-12",
            "color": "#dae2ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-container/opacity-0-16",
            "color": "#dae2ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-fixed/opacity-0-08",
            "color": "#00184914",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-fixed/opacity-0-12",
            "color": "#0018491f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-fixed/opacity-0-16",
            "color": "#00184929",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-fixed-variant/opacity-0-08",
            "color": "#20428f14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-fixed-variant/opacity-0-12",
            "color": "#20428f1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-secondary-fixed-variant/opacity-0-16",
            "color": "#20428f29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-surface/opacity-0-08",
            "color": "#c4c7c814",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-surface/opacity-0-12",
            "color": "#c4c7c81f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-surface/opacity-0-16",
            "color": "#c4c7c81f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-surface-variant/opacity-0-08",
            "color": "#bfc8cc14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-surface-variant/opacity-0-12",
            "color": "#bfc8cc1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-surface-variant/opacity-0-16",
            "color": "#bfc8cc29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary/opacity-0-08",
            "color": "#3f2e0014",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary/opacity-0-12",
            "color": "#3f2e001f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary/opacity-0-16",
            "color": "#3f2e0029",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-container/opacity-0-08",
            "color": "#ffdf9e14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-container/opacity-0-12",
            "color": "#ffdf9e1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-container/opacity-0-16",
            "color": "#ffdf9e29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-fixed/opacity-0-08",
            "color": "#261a0014",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-fixed/opacity-0-12",
            "color": "#261a001f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-fixed/opacity-0-16",
            "color": "#261a0029",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-fixed-variant/opacity-0-08",
            "color": "#5b430014",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-fixed-variant/opacity-0-12",
            "color": "#5b43001f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/on-tertiary-fixed-variant/opacity-0-16",
            "color": "#5b430029",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/outline/opacity-0-08",
            "color": "#8a929614",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/outline/opacity-0-12",
            "color": "#8a92961f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/outline/opacity-0-16",
            "color": "#8a929629",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/outline-variant/opacity-0-08",
            "color": "#40484c14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/outline-variant/opacity-0-12",
            "color": "#40484c1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/outline-variant/opacity-0-16",
            "color": "#40484c29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary/opacity-0-08",
            "color": "#b7c4ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary/opacity-0-12",
            "color": "#b7c4ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary/opacity-0-16",
            "color": "#b7c4ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-container/opacity-0-08",
            "color": "#0039b514",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-container/opacity-0-12",
            "color": "#0039b51f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-container/opacity-0-16",
            "color": "#0039b529",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-fixed/opacity-0-08",
            "color": "#dce1ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-fixed/opacity-0-12",
            "color": "#dce1ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-fixed/opacity-0-16",
            "color": "#dce1ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-fixed-dim/opacity-0-08",
            "color": "#b7c4ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-fixed-dim/opacity-0-12",
            "color": "#b7c4ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/primary-fixed-dim/opacity-0-16",
            "color": "#b7c4ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/scrim/opacity-0-08",
            "color": "#00000014",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/scrim/opacity-0-12",
            "color": "#0000001f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/scrim/opacity-0-16",
            "color": "#00000029",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary/opacity-0-08",
            "color": "#b2c5ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary/opacity-0-12",
            "color": "#b2c5ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary/opacity-0-16",
            "color": "#b2c5ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-container/opacity-0-08",
            "color": "#20428f14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-container/opacity-0-12",
            "color": "#20428f1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-container/opacity-0-16",
            "color": "#20428f29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-fixed/opacity-0-08",
            "color": "#dae2ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-fixed/opacity-0-12",
            "color": "#dae2ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-fixed/opacity-0-16",
            "color": "#dae2ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-fixed-dim/opacity-0-08",
            "color": "#b2c5ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-fixed-dim/opacity-0-12",
            "color": "#b2c5ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/secondary-fixed-dim/opacity-0-16",
            "color": "#b2c5ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/shadow/opacity-0-08",
            "color": "#00000014",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/shadow/opacity-0-12",
            "color": "#0000001f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/shadow/opacity-0-16",
            "color": "#00000029",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface/opacity-0-08",
            "color": "#11141514",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface/opacity-0-12",
            "color": "#1114151f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface/opacity-0-16",
            "color": "#11141529",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-bright/opacity-0-08",
            "color": "#363a3b14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-bright/opacity-0-12",
            "color": "#363a3b1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-bright/opacity-0-16",
            "color": "#363a3b29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container/opacity-0-08",
            "color": "#1d202114",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container/opacity-0-12",
            "color": "#1d20211f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container/opacity-0-16",
            "color": "#1d202129",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-high/opacity-0-08",
            "color": "#272a2b14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-high/opacity-0-12",
            "color": "#272a2b1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-high/opacity-0-16",
            "color": "#272a2b29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-highest/opacity-0-08",
            "color": "#32353614",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-highest/opacity-0-12",
            "color": "#3235361f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-highest/opacity-0-16",
            "color": "#32353629",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-low/opacity-0-08",
            "color": "#191c1d14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-low/opacity-0-12",
            "color": "#191c1d1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-low/opacity-0-16",
            "color": "#191c1d29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-lowest/opacity-0-08",
            "color": "#0b0f1014",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-lowest/opacity-0-12",
            "color": "#0b0f101f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-container-lowest/opacity-0-16",
            "color": "#0b0f1029",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-dim/opacity-0-08",
            "color": "#11141514",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-dim/opacity-0-12",
            "color": "#1114151f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-dim/opacity-0-16",
            "color": "#11141529",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-tint/opacity-0-08",
            "color": "#b7c4ff14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-tint/opacity-0-12",
            "color": "#b7c4ff1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-tint/opacity-0-16",
            "color": "#b7c4ff29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-variant/opacity-0-08",
            "color": "#40484c14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-variant/opacity-0-12",
            "color": "#40484c1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/surface-variant/opacity-0-16",
            "color": "#40484c29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary/opacity-0-08",
            "color": "#f2bf4814",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary/opacity-0-12",
            "color": "#f2bf481f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary/opacity-0-16",
            "color": "#f2bf4829",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-container/opacity-0-08",
            "color": "#5b430014",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-container/opacity-0-12",
            "color": "#5b43001f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-container/opacity-0-16",
            "color": "#5b430029",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-fixed/opacity-0-08",
            "color": "#ffdf9e14",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-fixed/opacity-0-12",
            "color": "#ffdf9e1f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-fixed/opacity-0-16",
            "color": "#ffdf9e29",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-fixed-dim/opacity-0-08",
            "color": "#f2bf4814",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-fixed-dim/opacity-0-12",
            "color": "#f2bf481f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "state-layers/brand/tertiary-fixed-dim/opacity-0-16",
            "color": "#f2bf4829",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/background",
            "color": "#191c1d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/error",
            "color": "#ffb4ab",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/error-container",
            "color": "#93000a",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/inverse-on-surface",
            "color": "#2d2d2d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/inverse-primary",
            "color": "#0053ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/inverse-surface",
            "color": "#f1f1f1",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-background",
            "color": "#e1e3e4",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-error",
            "color": "#690005",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-error-container",
            "color": "#ffdad6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-primary",
            "color": "#002e8f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-primary-container",
            "color": "#ccddff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-primary-fixed",
            "color": "#001c57",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-primary-fixed-variant",
            "color": "#0041c7",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-secondary",
            "color": "#2d3f47",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-secondary-container",
            "color": "#ebf0f2",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-secondary-fixed",
            "color": "#172024",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-secondary-fixed-variant",
            "color": "#425d69",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-surface",
            "color": "#f1f1f1",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-surface-variant",
            "color": "#bfc8cc",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-tertiary",
            "color": "#856a31",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-tertiary-container",
            "color": "#fcfaf6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-tertiary-fixed",
            "color": "#5c4922",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/on-tertiary-fixed-variant",
            "color": "#ae8b40",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/outline",
            "color": "#8a9296",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/outline-variant",
            "color": "#40484c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/primary",
            "color": "#a3c1ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/primary-container",
            "color": "#0041c7",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/primary-container-bright",
            "color": "#002e8f",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/primary-fixed",
            "color": "#ccddff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/primary-fixed-dim",
            "color": "#a3c1ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/scrim",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/secondary",
            "color": "#d2dee3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/secondary-container",
            "color": "#425d69",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/secondary-fixed",
            "color": "#ebf0f2",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/secondary-fixed-dim",
            "color": "#d2dee3",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/shadow",
            "color": "#000000",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface",
            "color": "#161819",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-bright",
            "color": "#3d3d3d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-container",
            "color": "#1d2021",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-container-high",
            "color": "#2b2b2b",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-container-highest",
            "color": "#333333",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-container-low",
            "color": "#191c1d",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-container-lowest",
            "color": "#0b0f10",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-dim",
            "color": "#121416",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-tint",
            "color": "#b7c4ff",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/surface-variant",
            "color": "#40484c",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/tertiary",
            "color": "#f1e9d8",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/tertiary-container",
            "color": "#ae8b40",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/tertiary-fixed",
            "color": "#fcfaf6",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "sys/brand/tertiary-fixed-dim",
            "color": "#f1e9d8",
            "var": "",
            "rootAlias": ""
          }
        ],
        "number": []
      }
    ]
  },
  {
    "name": "Breakpoints",
    "values": [
      {
        "mode": {
          "name": "Mobile",
          "id": "3059:2"
        },
        "color": [],
        "number": [
          {
            "name": "DeviceWidth",
            "value": "25.75rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "DeviceHeight",
            "value": "55.75rem",
            "var": "",
            "rootAlias": ""
          }
        ]
      },
      {
        "mode": {
          "name": "Tablet Portrait",
          "id": "3059:3"
        },
        "color": [],
        "number": [
          {
            "name": "DeviceWidth",
            "value": "52.125rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "DeviceHeight",
            "value": "74.625rem",
            "var": "",
            "rootAlias": ""
          }
        ]
      },
      {
        "mode": {
          "name": "Laptop",
          "id": "3060:4"
        },
        "color": [],
        "number": [
          {
            "name": "DeviceHeight",
            "value": "64rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "DeviceWidth",
            "value": "90rem",
            "var": "",
            "rootAlias": ""
          }
        ]
      },
      {
        "mode": {
          "name": "Desktop",
          "id": "3060:5"
        },
        "color": [],
        "number": [
          {
            "name": "DeviceHeight",
            "value": "75rem",
            "var": "",
            "rootAlias": ""
          },
          {
            "name": "DeviceWidth",
            "value": "120rem",
            "var": "",
            "rootAlias": ""
          }
        ]
      }
    ]
  }
]
